import { Skeleton } from 'antd';
import cn from 'classnames';

import type { FC } from 'react';

import './MessagesSkeleton.scss';

interface SkeletonMessageShape {
  side: 'left' | 'right';
  width: number;
}

const SKELETON_MESSAGES: SkeletonMessageShape[] = [
  { side: 'left', width: 220 },
  { side: 'right', width: 180 },
  { side: 'left', width: 280 },
  { side: 'left', width: 140 },
  { side: 'right', width: 240 },
  { side: 'left', width: 200 },
  { side: 'right', width: 120 },
  { side: 'left', width: 260 },
];

export const MessagesSkeleton: FC = () => (
  <div className="MessagesSkeleton" aria-busy="true" aria-live="polite">
    {SKELETON_MESSAGES.map((message, index) => (
      <div
        className={cn(
          'MessagesSkeleton__row',
          `MessagesSkeleton__row--${message.side}`
        )}
        key={index}
      >
        <Skeleton.Button
          className="MessagesSkeleton__bubble"
          active
          size="default"
          style={{ width: message.width }}
        />
      </div>
    ))}
  </div>
);
